export default function sidebar() {
  return {
    init() {
      const saved = localStorage.getItem("sidebar-collapsed");
      if (saved !== null) {
        Alpine.store("sidebar").collapsed = saved === "true";
      }

      // Mobile toggle
      const toggleBtn = document.getElementById("sidebar-toggle");
      const backdrop = document.getElementById("sidebar-backdrop");
      const sidebarEl = this.$el;

      if (toggleBtn) {
        toggleBtn.addEventListener("click", () => {
          sidebarEl.classList.toggle("-translate-x-full");
          backdrop.classList.toggle("hidden");
        });
      }

      if (backdrop) {
        backdrop.addEventListener("click", () => {
          sidebarEl.classList.add("-translate-x-full");
          backdrop.classList.add("hidden");
        });
      }
    },

    get collapsed() {
      return Alpine.store("sidebar").collapsed;
    },

    toggle() {
      const store = Alpine.store("sidebar");
      store.collapsed = !store.collapsed;
      localStorage.setItem("sidebar-collapsed", store.collapsed);
    },
  };
}
